export const FAILED_UTTERANCE_NOTICE_MS = 4000;
export const ERROR_NOTICE_MS = 6000;
